import { ScrollToTop } from "./ScrollToTop";
import App from "./App";
import { AppState, Auth0Provider, User } from "@auth0/auth0-react";
import config from "./store/authStore/auth0.config";

export function Root() {
  function onRedirectCallback(
    appState?: AppState | undefined,
    user?: User | undefined
  ): void {
    const returnTo =
      appState && appState.returnTo
        ? `${window.location.origin}${appState.returnTo}`
        : window.location.origin;

    window.history.replaceState(user, document.title, returnTo);
  }
 
  return (
    <>
      <Auth0Provider
        domain={config?.domain}
        clientId={config?.clientId}
        authorizationParams={{
          redirect_uri: window.location.origin,
          audience: config?.audience,
          scope: config?.scope,
        }}
        onRedirectCallback={onRedirectCallback}
      >
        <ScrollToTop />
        <App />
      </Auth0Provider>
    </>
  );
}
